export default __webpack_public_path__ + "static/media/karenying-design-2.1c6dc38d.png";